module.exports = __webpack_public_path__ + "static/service-hero-mobile-6c855a4b03986c8ab4c08aab03c0dba2.png";